import React from "react";
import { Container, Typography, Box, Divider, useTheme } from "@mui/material";
import CroboContainer from "../components/croboContainer";

const ReferralProgramTerms = () => {
  const theme = useTheme();

  const sectionStyles = {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
    padding: '24px',
    borderRadius: '8px',
    marginBottom: '24px',
  };

  const headingStyles = {
    color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main,
    fontWeight: 600,
    marginBottom: '16px',
  };

  return (
    <CroboContainer>
      <Container maxWidth="md">
        <Box sx={{ py: 6 }}>
          <Typography 
            variant="h5" 
            align="center" 
            gutterBottom
            sx={{
              fontWeight: 700,
              mb: 3,
              color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main,
            }}
          >
            Referral Program Terms and Conditions
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography 
            variant="h6" 
            gutterBottom 
            sx={{ 
              mb: 4,
              textAlign: 'center',
              color: theme.palette.text.secondary,
            }}
          >
            Welcome to our Referral Program! By participating in this program,
            you agree to the following terms and conditions:
          </Typography>

          <Box sx={sectionStyles}>
            <Typography variant="h5" sx={headingStyles}>
              Eligibility
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • The referral program is open to all registered users of our platform.
              <br />
              • Both the referrer and the referred must be legitimate users of the service.
            </Typography>
          </Box>

          <Box sx={sectionStyles}>
            <Typography variant="h5" sx={headingStyles}>
              Referral Reward
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • Both the referrer and the referred user will receive a $25 Amazon Gift Card.
              <br />
              • The referral reward will be issued once the referred user completes a minimum transaction of $500 and above on our platform.
            </Typography>
          </Box>

          <Box sx={sectionStyles}>
            <Typography variant="h5" sx={headingStyles}>
              Referral Limit
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • There is no limit to the number of referrals a user can make. You can refer as many friends and family members as you like.
            </Typography>
          </Box>

          <Box sx={sectionStyles}>
            <Typography variant="h5" sx={headingStyles}>
              Reward Conditions
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • The referred user must complete a transaction of $500 and above.
              <br />
              • The referrer will only receive the reward if the referred user completes the minimum transaction requirement.
            </Typography>
          </Box>

          <Box sx={sectionStyles}>
            <Typography variant="h5" sx={headingStyles}>
              Reward Issuance
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • Amazon Gift Cards will be emailed to the email addresses registered with the referrer and referred user's accounts within 7 days after the referred user completes the qualifying transaction.
            </Typography>
          </Box>

          <Box sx={sectionStyles}>
            <Typography variant="h5" sx={headingStyles}>
              Fraudulent Activity
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • Any fraudulent or abusive behavior, gaming of the system, or violation of these terms will result in disqualification from the referral program and forfeiture of any rewards.
            </Typography>
          </Box>

          <Box sx={sectionStyles}>
            <Typography variant="h5" sx={headingStyles}>
              Modification and Termination
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • We reserve the right to modify or terminate the referral program at any time without prior notice. Changes to the terms and conditions will be posted on our website.
            </Typography>
          </Box>

          <Box sx={sectionStyles}>
            <Typography variant="h5" sx={headingStyles}>
              General Conditions
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • Participation in the referral program is voluntary.
              <br />
              • Referral rewards are non-transferable, non-exchangeable, and non-refundable.
              <br />
              • We are not responsible for any lost or stolen Amazon Gift Cards.
              <br />
              • In case of any dispute, our decision will be final and binding.
              <br />
              • The referral program is subject to all applicable federal, state, and local laws and regulations.
            </Typography>
          </Box>

          <Box sx={sectionStyles}>
            <Typography variant="h5" sx={headingStyles}>
              Contact Information
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • If you have any questions or concerns regarding the referral program, please contact our support team at{" "}
              <Box
                component="a"
                href="mailto:care@crobo.money"
                sx={{
                  color: theme.palette.primary.main,
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                care@crobo.money
              </Box>
            </Typography>
          </Box>

          <Box sx={{ 
            mt: 6, 
            p: 3, 
            textAlign: 'center',
            borderTop: `1px solid ${theme.palette.divider}`,
          }}>
            <Typography 
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
                maxWidth: '800px',
                margin: '0 auto',
              }}
            >
              By participating in this referral program, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions. Thank you for being a part of our community and helping us grow!
            </Typography>
          </Box>
        </Box>
      </Container>
    </CroboContainer>
  );
};

export default ReferralProgramTerms;
